import React from 'react';
import { Link } from 'react-router-dom';
import useSEO from '../hooks/useSEO';

export default function Error404() {
  useSEO('Siden blev ikke fundet (404) | Chokolenten ApS', 'Siden blev ikke fundet.');

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-16">
      <div className="max-w-md w-full text-center bg-cream-light p-8 sm:p-12 rounded-2xl border border-choc-dark/10 shadow-lg flex flex-col items-center gap-6 animate-in zoom-in-95 duration-200">
        
        {/* Ikon */}
        <div className="w-20 h-20 rounded-full bg-berry-accent/10 flex items-center justify-center text-berry-accent relative">
          <i className="fa-solid fa-cookie-bite text-4xl" />
          <i className="fa-solid fa-question text-lg absolute -top-1 -right-1 bg-choc-dark text-cream-light w-6 h-6 rounded-full flex items-center justify-center border-2 border-cream-light" />
        </div>

        {/* Overskrift */}
        <div className="flex flex-col gap-2">
          <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">Fejl 404</span>
          <h1 className="text-3xl font-serif font-bold text-choc-dark">
            Hov, der røg en Thy Kukie!
          </h1>
        </div>

        {/* Beskrivelse */}
        <p className="text-sm text-choc-dark/70 font-sans leading-relaxed">
          Siden, du leder efter, findes desværre ikke. Den er måske blevet flyttet, slettet eller spist af en chokolade-elsker!
        </p>

        {/* Knapper */}
        <div className="flex flex-col gap-2 w-full mt-2">
          <Link
            to="/"
            className="w-full bg-berry-accent hover:bg-berry-accent/90 text-white font-sans font-semibold py-3 px-4 rounded-xl transition-colors shadow-sm cursor-pointer"
          >
            Gå til forsiden
          </Link>
          <Link
            to="/produkter/chokolade"
            className="w-full bg-transparent hover:bg-choc-dark/5 text-choc-dark border border-choc-dark/20 font-sans font-semibold py-3 px-4 rounded-xl transition-colors cursor-pointer"
          >
            Se vores lækre produkter
          </Link>
        </div>

      </div>
    </div>
  );
}
